import { computed, inject } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { WorkspaceState } from './workspace.state';
import { Workspace, WorkspaceTypeKey } from '../../models/workspace';
import { Role } from '../../models/rbac';
import { RoleStore } from '../role/role.state';

export function withWorkspaceSelectors() {
  return signalStoreFeature(
    {
      state: type<WorkspaceState>(),
    },
    withMethods((store, roleStore = inject(RoleStore)) => ({
      filterByType(type: WorkspaceTypeKey) {
        return Object.values(store.items()).filter(item => {
          return item.type === type;
        }) as Workspace[];
      },
    })),
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      asGroupedByType: computed(() => {
        return Object.values(items()).reduce(
          (acc: { [key: string]: Workspace[] }, item: Workspace) => {
            acc[item.type] = acc[item.type] || [];
            acc[item.type].push(item);
            return acc;
          },
          {}
        );
      }),
    }))
  );
}
